<app-sessions-topics-header *ngIf="!newIdea">
  <topic-type-switcher
    [(type)]="sessionType"
    *ngIf="topicClusters.length > 0"></topic-type-switcher>
</app-sessions-topics-header>
<div class="new-idea-header" *ngIf="newIdea">
  <img alt src="assets/images/new-idea-topics-header.svg" *ngIf="newIdea" />
  <h1>Pick the Topic for your New Project!</h1>
  <ng-container *ngIf="topicClusters.length > 0">
    <br />
    <br />
    <topic-type-switcher [(type)]="sessionType"></topic-type-switcher>
  </ng-container>
</div>

<div class="container-fluid sub-navigation chrome-no-repaint">
  <div class="container">
    <!-- Filter Bar Start -->
    <div class="row">
      <div class="col-lg-3 top-buffer">
        <span>Filter by</span>
        <div class="btn-group filter-dropdown" ngbDropdown>
          <div
            id="btn-append-to-single-button"
            class="filter-button"
            ngbDropdownToggle>
            {{ selectedFilterRepresentation }}
            <span class="caret"></span>
          </div>
          <ul class="dropdown-menu filter-list shadow" ngbDropdownMenu>
            <li role="menuitem">
              <a
                class="dropdown-item"
                [ngClass]="{ active: sessionFilter === 'all' }"
                (click)="
                  sessionFilter = 'all';
                  selectedFilter = 'All Topics';
                  filterOwn = false;
                  filterFav = false
                ">
                All {{ sessionType === 'Topic' ? 'Topics' : 'Topic Clusters' }}
              </a>
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                [ngClass]="{ active: sessionFilter === 'own' }"
                (click)="
                  sessionFilter = 'own';
                  selectedFilter = 'Own Topics';
                  filterOwn = true;
                  filterFav = false
                ">
                Own {{ sessionType === 'Topic' ? 'Topics' : 'Topic Clusters' }}
              </a>
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                [ngClass]="{ active: sessionFilter === 'favorites' }"
                (click)="
                  sessionFilter = 'favorites';
                  selectedFilter = 'Favorite Topics';
                  filterOwn = false;
                  filterFav = true
                ">
                Favorite
                {{ sessionType === 'Topic' ? 'Topics' : 'Topic Clusters' }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="col-lg-2 top-buffer"
        *ngIf="featureFlags.reportGeneration && topics.length">
        <a class="pdf-button" (click)="openPdfSelectionModal()">
          <i class="icon-file-pdf"></i>
          Get Topic Reports (PDF)
        </a>
      </div>

      <div class="col-lg-4"></div>

      <div class="col-lg-2 position-relative">
        <a class="submenu-cta" routerLink="/topic/new">
          <i class="icon-session"></i>
          <span>New Topic</span>
        </a>
      </div>
    </div>
    <!-- Filter Bar END -->
  </div>
</div>

<div
  class="container ideation-module-container no-background chrome-no-repaint">
  <!-- Ideation Sessions Start -->
  <h4 *ngIf="filteredParticipating.length">Participating (or moderating):</h4>
  <div class="row">
    <ng-container *ngFor="let session of filteredParticipating">
      <session-card
        class="col-lg-6 col-12"
        [session]="session"
        [newIdea]="newIdea"></session-card>
    </ng-container>
  </div>

  <h4 *ngIf="filteredEvaluating.length">Evaluating:</h4>
  <div class="row">
    <ng-container *ngFor="let session of filteredEvaluating">
      <session-card
        class="col-lg-6 col-12"
        [session]="session"
        [newIdea]="newIdea"></session-card>
    </ng-container>
  </div>

  <!-- Ideation Sessions End -->
  <ng-container *ngIf="!sessionsLoaded">Loading topics ...</ng-container>
  <ng-container *ngIf="!sessions.length && sessionsLoaded">
    <span class="empty">
      <img alt src="/assets/images/empty-row.svg" />
      <span>No topics here? Add the first!</span>
    </span>
  </ng-container>
</div>
